import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import PageContent from "./content";

const Home = () => {
	return (
		<>
			<Header />
			<PageContent />
			<Footer />
		</>
	);
};
export default Home;
